export function createAiEvent(type, text, id, status) {
  return {
    id: id || crypto.randomUUID(),
    type,
    text,
    status,
    ts: Date.now(),
  };
}
